/* eslint-disable react/forbid-prop-types */
import { useEffect } from 'react'
import { withRouter } from 'react-router'
import MobileSearchBar from 'shared/mobile-search-bar'
import { withContextualizedTracking, track } from 'lib/analytics'
import * as BLConstants from 'shared/constants'
import SubNav from './sub-nav'
import { getTopLevelTopicSlugFromPath } from '../lib'
import { helloBabySearchPath } from '../../lib/urls'
import { useSelector } from 'react-redux'

interface AppProps {
  children: React.ReactNode
  location: any
  minimalView: boolean
  path: string | null | undefined
  router: any
  topicNavigation: any
}

const App = ({
  children,
  location,
  minimalView,
  path,
  router,
  topicNavigation,
}: AppProps) => {
  const state = useSelector((state) => state as any)
  const { posts } = state

  useEffect(() => {
    PubSub.subscribe(BLConstants.ROUTE_CHANGE, (path) => {
      router.push(path)
    })
  }, [])

  return (
    <div style={{ minHeight: 'calc(100vh)' }}>
      {!minimalView ? (
        <SubNav
          className="hidden-xs"
          searchTerm={location.query.search_term}
          topicSlug={getTopLevelTopicSlugFromPath(
            location.pathname.includes('preview') ? path : location.pathname,
            posts,
            state
          )}
          topics={topicNavigation.items}
        />
      ) : null}

      {!minimalView ? (
        <MobileSearchBar
          placeholder="Search guides"
          submitPath={helloBabySearchPath}
        />
      ) : null}
      {children}
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.HOME_PAGE,
})(withRouter(App))
